import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { authenticationRequired } from "@/authentication";
import {
  peruvianRoutes,
  adminRoutes,
  development
} from "@/dynamic.routes";
import HomeNew from "@/views/HomeNew.vue";
import RutasActividad from "@/routes/rutas.actividad";
import RutasPublicas from "@/routes/rutas.publicas";
import RutasPrivadas from "@/routes/rutas.privadas";
import DashboardRoutes from "@/router.dashboard";
import DashboardRoutesFactoring from "@/router.dashboard.factoring";
import { EventBus } from "@/main";
import { isUserLogin } from "./utils";
import { SelectedCountry, State } from "./configuration";

Vue.use(Router);
const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...RutasPublicas,
    ...RutasPrivadas,
    ...RutasActividad,
    {
      path: "/invertir",
      name: "investment",
      component: () =>
        import(
          /* webpackChunkName: "investment-opportunities" */ "@/views/Investment.vue"
        ),
      beforeEnter: (to: any, from: any, next: any) => {
        if (SelectedCountry == "PYME") {
          next("/");
        } else {
          isUserLogin(
            () => {
              next();
            },
            () => {
              if (SelectedCountry == "PE") {
                store.commit("logout");
                next(`/ingresar?return=${to.path}`);
              } else {
                next();
              }
            }
          );
        }
      }
    },
    
    {
      path: "/reserva-exitosa",
      name: "successful-reserving",
      component: () =>
        import(
          /* webpackChunkName: "successful-reserving" */ "@/views/SuccessfulReserving.vue"
        )
    },
    
    ...DashboardRoutes.map(route => {
      route.path = `/panel/${route.path}`;
      route.name = `dashboard-${route.name}`;
      route.beforeEnter = authenticationRequired;
      return route;
    }),
    ...DashboardRoutesFactoring.map(route => {
      route.path = `/panel-facto/${route.path}`;
      route.name = `dashboard-factoring-${route.name}`;
      route.beforeEnter = authenticationRequired;
      return route;
    }),
    {
      path: "/404",
      name: "404",
      component: () => import("@/views/404.vue")
    },
    {
      path: "*",
      name: "not-found",
      redirect: "/404"
    },
    {
      path: "/mantenimiento",
      name: "mantenimiento",
      component: () => import("@/views/404-mantain.vue"),
      beforeEnter: development
    },
    {
      path: "/estamos-trabajando",
      name: "trabajando",
      component: () => import("@/views/404-working.vue"),
      beforeEnter: development
    }
  ]
});

router.afterEach((to, from) => {
  if (State == 2) {
    if (to.path != "/mantenimiento") {
      router.push({ path: "/mantenimiento" });
    }
  }
  if (State == 3) {
    if (to.path != "/estamos-trabajando") {
      router.push({ path: "/estamos-trabajando" });
    }
  }
});
router.afterEach((to, from) => {
  if(to.fullPath.indexOf('/panel') == 0){
    store.commit("setShowPanelInv",true)
  } else {
    store.commit("setShowPanelInv",false)
  }
  store.commit("setRoutes", { to: to.path, from: from.path });
});

// router.afterEach((to, from) => {
//   store.commit("setRoutes", { to: to.path, from: from.path });
// });

const r = router;
// @ts-ignore
// console.log(r.options.routes)

function getRoutesList(routes: any, pre: any) {
  return routes.reduce((array: any, route: any) => {
    const path = `${pre}${route.path}`;

    if (route.path !== "*") {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }
    // console.log(array)
    return array;
  }, []);
}

export default router;
